export const common = {
  nav: {
    home: 'POČETNA',
    registration: 'PRIJAVA',
    regulations: 'PRAVILNIK',
    registerNow: 'PRIJAVI SE SADA',
  },
  hero: {
    title: 'SINJAVINA SKYRACE 2026',
    date: '6. JUNI 2026',
    location: 'MOJKOVAC, CRNA GORA',
    description: 'Doživite vrhunski izazov planinskog trčanja u srcu netaknute divljine Crne Gore',
    cta: 'PRIJAVI SE SADA',
  },
  races: {
    title: 'IZABERITE SVOJ IZAZOV',
    skyrace: {
      badge: 'ULTRA',
      title: 'SINJAVINA SKYRACE',
      distance: 'Udaljenost: 40km',
      elevation: 'Uspon: 2000m D+',
      timeLimit: 'Vremensko ograničenje: 8 sati',
      maxAltitude: 'Maksimalna nadmorska visina: 1863m',
      description: 'Vrhunski skyrunning izazov kroz Sinjavinu, prelazak planinskih prevoja, tradicionalnih katuna, sa ciljem na gradskom trgu u Mojkovcu.',
      button: 'PRIJAVI SE - SKYRACE',
    },
    miniSkyrace: {
      badge: 'KRATKA',
      title: 'SINJAVINA MINI SKYRACE',
      distance: 'Udaljenost: 10km',
      elevation: 'Uspon: 1000m D+',
      timeLimit: 'Vremensko ograničenje: 3 sata',
      maxAltitude: 'Maksimalna nadmorska visina: 1734m',
      description: 'Savršen uvod u planinske trke, sa ciljem na prekrasnom Zabojskom jezeru. Idealno za početnike i one koji traže kraći izazov.',
      button: 'PRIJAVI SE - MINI SKYRACE',
    },
  },
  highlights: {
    title: 'ZAŠTO SINJAVINA SKYRACE',
    nature: {
      title: 'NETAKNUTA PRIRODA',
      description: 'Trčite kroz netaknute planinske pejzaže, tradicionalna pastirska naselja i kristalno čista planinska jezera',
    },
    experience: {
      title: 'AUTENTIČNO ISKUSTVO',
      description: 'Doživite pravu crnogorsku planinsku kulturu sa lokalnom podrškom, tradicionalnom hranom i toplom gostoljubivošću',
    },
    organization: {
      title: 'PROFESIONALNA ORGANIZACIJA',
      description: 'Dobro označene staze, višestruke okrepne stanice, sigurnosna podrška i iskusna organizacija planinskih trka',
    },
  },
  tracks: {
    title: 'STAZE TRKE',
    description: 'Preuzmite zvanične GPS staze za obje udaljenosti trke',
    button: 'PREUZMI STAZE',
  },
  location: {
    title: 'LOKACIJA TRKE',
    startPoint: 'POČETNA TAČKA: HOTEL RAVNJAK',
    address: 'SELO BISTRICA, MOJKOVAC',
    coordinates: '42.989524, 19.410788',
    description: 'Smješteno u srcu planinskog regiona Crne Gore, lako dostupno iz Podgorice (90km) i okruženo zadivljujućom prirodnom ljepotom',
  },
  footer: {
    tagline: 'Vodeća planinska trka Crne Gore',
    quickLinks: 'BRZI LINKOVI',
    contact: 'KONTAKT',
    email: 'Email',
    phone: 'Telefon',
    locationLabel: 'Lokacija',
    copyright: '© 2026 Sinjavina Skyrace. Sva prava zadržana.',
    poweredBy: 'Powered by AvaiBookSports.com',
  },
};